/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  adminDeleteOrders,
  adminOrders,
  adminUpdateOrders,
  getOrders
} from '../../api/api'

export const getOrdersAdmin =
  () => async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    const data = await adminOrders()
    console.log(data)
    dispatch({
      type: 'GET_ALL_ORDERS',
      payload: data.data.orders
    })
  }
export const deleteOrderById =
  (id: string) =>
    async (dispatch: (arg0: { type: string; payload: any }) => void) => {
      const data = await adminDeleteOrders(id)
      console.log(data)
      dispatch({
        type: 'DELETE_ORDER',
        payload: data.data.orders
      })
    }
export const updateOrderStatus =
  (status: unknown) =>
    async (dispatch: (arg0: { type: string; payload: any }) => void) => {
      const data = await adminUpdateOrders(status)
      console.log(data)
      dispatch({
        type: 'UPDATE_STATUS_ORDER',
        payload: data.data.orders
      })
    }

const getOrdersUserAPI = createAsyncThunk('order/get-orders', async () => {
  const response = await getOrders()
  return response.data
})

export { getOrdersUserAPI }
